/**
 * Shared mutable state for the FLIP transition between inventory cards
 * and the equipment detail view. Written by EquipmentCard on click
 * (the card's bounding rect at click time), read by EquipmentDetailView
 * to animate the detail layout from the card's source position.
 *
 * Replaces the module-scope `let _flipSourceRect` from the pre-Vite
 * single-file SPA (old index.html line 6000).
 */
export const flipState = {
  sourceRect: null,
};
